"use client";
import { apiService } from "@/services/api.services";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import "./RecentBlog.css";
import Link from "next/link";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const RecentBlog = ({ FilterKeyword = "-" }) => {
  const [recentBlogList, setRecentBlogList] = useState([]);
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", options);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiService.getRecentBlogWithkeySearch({
          keyword: FilterKeyword,
        });
        if (response.status === 200) {
          setRecentBlogList(response.data?.data);
        }
      } catch (error) {
        console.log(error);
      }
    }

    fetchData();
  }, [FilterKeyword]);

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", color: "#002E5D" }}
        onClick={onClick}
      />
    );
  }

  const settings = {
    dots: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
        },
      },
    ],
  };

  // Limit the blogs to the first 3
  const latestBlogs = recentBlogList?.slice(0, 3);

  return latestBlogs?.length ? (
    <>
      <h2 className="feature_subheading txt_center">Latest Blogs</h2>
      <p className="blog_content blog_contentsub upcomingblog">
        Here is our collection of the most relevant workplace and employer insights.
      </p>
      <div className="blog_container">
        <div className="blog_container_right">
          <Slider {...settings}>
            {latestBlogs?.map((blog, index) => (
              <Link href={`/blog/${blog?.attributes?.url_index}`} key={index}>
                <div className="blog_card" key={index}>
                  <div className="blog_card_img_container">
                    {blog?.attributes?.image?.data?.attributes?.url && (
                      <Image
                        src={blog?.attributes?.image?.data?.attributes?.url}
                        alt={blog?.attributes?.meta_title ?? "blog_img"}
                        className="blog_card_img"
                        width={380}
                        height={340}
                      />
                    )}
                  </div>
                  <div className="bloglist_cardbottom">
                    <p className="bloglist-date">
                      {blog?.attributes?.publishedAt &&
                        formatDate(blog?.attributes?.publishedAt)}
                    </p>
                    <p className="bloglist-name">
                      {blog.attributes.title.length > 55
                        ? `${blog.attributes.title.slice(0, 60)}...`
                        : blog.attributes.title}
                    </p>
                    <p className="bloglist-desc">
                      {blog?.attributes?.meta_desp?.length > 110
                        ? `${blog?.attributes?.meta_desp.slice(0, 110)}...`
                        : blog?.attributes?.meta_desp}
                    </p>
                  </div>
                </div>
              </Link>
            ))}
          </Slider>
        </div>
      </div>
    </>
  ) : null;
};

export default RecentBlog;
